import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ABOUT, PROFILE } from "../../data/content";
import { Reveal } from "./Reveal";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Portrait, clipped, offset */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <motion.div style={{ y }} className="relative max-w-[420px]">
              <div className="overflow-hidden border border-foreground/15">
                <img
                  src={PROFILE.portrait}
                  alt={PROFILE.name}
                  className="w-full h-auto object-cover grayscale-[15%]"
                  data-testid="about-portrait"
                />
              </div>
              <div className="mt-4 font-mono-accent text-[10px] uppercase tracking-[0.2em] text-muted-foreground flex justify-between">
                <span>{PROFILE.role}</span>
                <span>India</span>
              </div>
            </motion.div>
          </div>

          {/* Copy */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <Reveal>
              <p className="font-mono-accent text-xs uppercase tracking-[0.22em] text-accent mb-6">
                {ABOUT.overline}
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-serif-display font-medium tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-2xl">
                {ABOUT.heading}
              </h2>
            </Reveal>
            <div className="mt-10 space-y-6 max-w-2xl">
              {ABOUT.paragraphs.map((p, i) => (
                <Reveal key={i} delay={0.1 + i * 0.05}>
                  <p className="text-base md:text-lg leading-relaxed text-foreground/80">
                    {p}
                  </p>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2}>
              <p
                className="mt-10 font-serif-display italic text-3xl text-accent"
                data-testid="about-signature"
              >
                {ABOUT.signature}
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
